import { render } from "./textAnswer.vue?vue&type=template&id=ec6c2880&scoped=true"
import script from "./textAnswer.vue?vue&type=script&lang=js"
export * from "./textAnswer.vue?vue&type=script&lang=js"

import "./textAnswer.vue?vue&type=style&index=0&id=ec6c2880&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec6c2880"]])

export default __exports__